<template>
  <div class="x-admin-user-info">
<!--    <Avatar class="x-admin-user-info__avatar" size="small" :src="image"></Avatar>-->
    <span class="x-admin-user-info-avatar-text">{{shortName}}</span>
    <Dropdown class="x-admin-user-info__dropdown" @command="handleCommand">
      <div>
        <Badge v-if="badge" v-bind="badge">
          {{name}}
        </Badge>
        <span v-else>{{name}}</span>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </div>

      <DropdownMenu slot="dropdown" class="x-admin-user-info__menu">
        <DropdownItem v-for="item in tools"
                      :key="item.name"
                      :divided="item.divided"
                      :disabled="item.disabled"
                      :command="item.name">
          <span :class="item.className" v-html="item.label"></span>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>

<script>
import {
  // Avatar,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Badge
} from 'element-ui';
import {isEmpty} from '@/util/appUtils';

// import defaultAvatar from '../assets/avatar.png';

export default {
  inheritAttrs: false,
  inject: ['$admin'],
  components: {
    // Avatar,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Badge
  },
  props: {
    defaultAvatar: {
      type: String,
      // default: defaultAvatar
      default: null
    },
    avatar: {
      type: String
    },
    name: String,
    tools: Array,
    badge: {
      type: [Boolean, Object]
    }
  },
  computed: {
    image() {
      return this.avatar || this.defaultAvatar;
    },
    shortName() {
      if (isEmpty(this.name)) {
        return '';
      }
      if (this.name.length < 2) {
        return this.name;
      }
      return this.name.substring(this.name.length - 2, this.name.length);
    }
  },
  methods: {
    handleCommand(command) {
      this.$emit('command', command);
      this.$admin.$emit('user-tool-click', command);
    }
  }
};
</script>
<style lang="scss">
@import "../../../style/variables";
.x-admin-user-info-avatar-text {
  font-size: 12px;
  font-weight: bold;
  color: #ffffff;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  background-color: $primary-color;
  margin-right: 5px;
}
</style>
